import React from 'react';
import classNames from 'classnames';

import { Appearance, HIGHLIGHT_COLOR } from '../../colors/colors';
import MoreInfoIcon, { type MoreInfoIconProps } from '../MoreInfoIcon/MoreInfoIcon';
import OverflowTextTooltip from '../Text/OverflowTextTooltip';

import TextFieldErrorWarningMessage from './TextFieldErrorWarningMessage';

export type CaptionDirection = 'vertical' | 'horizontal';
export interface CaptionProps {
  caption: string;
  captionDirection: 'vertical' | 'horizontal';
  captionSize: 'medium' | 'long';
  moreInfoIconProps: MoreInfoIconProps | undefined;
}
type TextFieldCaptionProps = CaptionProps & {
  appearance?: Appearance;
  /**
   * TextFields with horizontal captions and error/warning messages need to stub the
   * vertical space taken up by the message under the input.
   */
  showErrorWarningMessage: boolean;
};

function TextFieldCaption({
  caption,
  captionDirection,
  captionSize,
  appearance,
  moreInfoIconProps,
  showErrorWarningMessage,
}: TextFieldCaptionProps): JSX.Element | null {
  return (
    <label
      className={classNames('label text-style-caption', {
        // TODO(youngxguo) make this configurable via props in the future.
        // For now, there are no use-case for more sizes, so all horizontal captions are medium.
        [`label-${captionSize}`]: captionDirection === 'horizontal',
      })}
    >
      <div
        className="label-contents"
        data-testid="text-field-label-contents"
        style={appearance === Appearance.HIGHLIGHT ? { color: HIGHLIGHT_COLOR } : {}}
      >
        {caption && <OverflowTextTooltip text={caption} />}
        {moreInfoIconProps && <MoreInfoIcon {...moreInfoIconProps} />}
      </div>
      {captionDirection === 'horizontal' && showErrorWarningMessage && (
        <TextFieldErrorWarningMessage
          errorMessage={undefined}
          validationErrorMessage={undefined}
          warningMessage={undefined}
          stub
        />
      )}
    </label>
  );
}

export default TextFieldCaption;
